import { Moment } from "moment";
import { ContentTable, DynamicRowSize, Table } from "pdfmake/interfaces";
import { MonatsabschlussZeile } from "@/api/Abrechnung";
import { MONATSNAMEN } from "@/api/Termine";
import { getQuittungRechnungFooter, getQuittungRechnungHeader } from "./common";
import { format } from "../util";

export function createQuittungsblatt(
  monat: Moment,
  zeile: MonatsabschlussZeile
): ContentTable {
  const table: Table = {
    widths: [100, "*", 95, 95, 100],
    heights: ((rowNumber: number) => 5) as DynamicRowSize,
    body: [
      ...getQuittungRechnungHeader(zeile),
      [
        { text: "Quittung", style: "header", },
        { text: "Im Monat", style: "fett", alignment: "right" },
        {
          text: MONATSNAMEN[monat.month()] + " / " + monat.year(),
          style: "fett",
        },
        {},
        {},
      ],
      [
        {},
        { text: "Düsselorfer Verfahren am Tag 25 €", style:"fett", colSpan: 2 },
        {},
        {},
        {},
      ],
      [
        {},
        { text: "" + zeile.anzahlDiensteSteuerpflichtig, bold: true, alignment: "right", },
        { text: "Tage x 25 € =", bold: true, alignment: "center", },
        { text: format(zeile.steuer, false, 2), },
        {},
      ],
      ...getQuittungRechnungFooter(zeile),
    ],
  };

  return {
    pageBreak: "before",
    layout: "quittung", // siehe pdfStyles.ts
    table,
    margin: [35, 40, 30, 25],
  };
}
